<template>
  <RouterLink
    class="nav-link"
    :class="{ 'nav-link--active': $route.name == route || (route == '/' && $route.name == 'home') }"
    :to="{ name: route }"
  >
    <span class="nav-link__indicator" />
    <i :class="icon" class="nav-link__icon" />
    <span class="nav-link__text">{{ text }}</span>
  </RouterLink>
</template>

<script>
  export default {
    name: 'SideBarLink',
    props: ['route', 'text', 'icon'],
  }
</script>

<style scoped>
.nav-link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 12px;
  margin: 1px 8px;
  border-radius: 8px;
  text-decoration: none;
  color: var(--app-text-muted);
  font-size: 0.875rem;
  font-weight: 500;
  transition: background 0.12s, color 0.12s;
  overflow: hidden;
}
.nav-link__indicator {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scaleY(0);
  width: 3px;
  height: 55%;
  background: var(--primary);
  border-radius: 0 3px 3px 0;
  transition: transform 0.15s ease;
}
.nav-link__icon {
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}
.nav-link:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--app-text);
}
.nav-link--active {
  background: var(--primary-muted);
  color: var(--primary);
  font-weight: 600;
}
.nav-link--active .nav-link__indicator {
  transform: translateY(-50%) scaleY(1);
}
</style>
